export const GET_USER_MANAGEMENT = 'ANNOUNTCEMENT/get_user-_management';
export const GET_SINGLE_USER_MANAGEMENT = 'ANNOUNTCEMENT/get_single_user_management';
export const UPDATE_USER_MANAGEMENT = 'ANNOUNTCEMENT/update_user-_management';
export const CREATE_USER_MANAGEMENT = 'ANNOUNTCEMENT/create_brangay';
export const REMOVE_USER_MANAGEMENT = 'ANNOUNTCEMENT/remove_user_management';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  photo: '',
  title: '',
  description: '',
  start_date: '',
  end_date: ''
};
